<template>
  <transition name="vi-modal">
    <div class="vi-modal call-details" v-if="currentSessionLog" @click.stop="close">
      <div class="vi-modal-content" @click.stop="stopPropagation">
        <div class="call-details-content">
          <div class="session-details">
            <div class="contact-name">{{currentSessionLog.contact.name}} <span><fa-icon icon="stopwatch" fixed-width/> {{duration}}</span>
            </div>
            <div class="session-details-block">
              <div>Start:</div>
              <div>{{formatDate(currentSessionLog.initiatedAt)}}</div>
              <div>{{formatTime(currentSessionLog.initiatedAt)}}</div>
            </div>
            <div class="session-details-block">
              <div>End:</div>
              <div>{{formatDate(currentSessionLog.endedAt)}}</div>
              <div>{{formatTime(currentSessionLog.endedAt)}}</div>
            </div>
            <div class="session-details-block">
              <div>Device:</div>
              <div>{{getLogPlatform(currentSessionLog.platform)}}</div>
              <div>IP: {{currentSessionLog.customerIpAddress}}</div>
            </div>
          </div>
          <div class="close-modal" @click="close">
            <img src="../../assets/icon_clear.svg"/>
          </div>
          <div class="call-details-scrollable" ref="scrollable">
            <div class="call-details-blocks">
              <div class="block">
                <recording-preview :session-log="currentSessionLog"/>
              </div>
              <div class="block">
                <notes-preview :session-log="currentSessionLog"/>
              </div>
            </div>

            <screenshots-preview
              :session-log="currentSessionLog"
              @scrollScreenshots="scrollToBottom"
            />

            <files-preview
              v-if="currentSessionLog.files"
              :files="currentSessionLog.files"
            />

            <div class="call-details-blocks" v-if="this.currentSessionLog.coordinates">
              <div class="block">
                <GmapMap
                  :center="center"
                  :options="options"
                  :zoom="15"
                  :disableDefaultUi="false"
                  :streetViewControl="false"
                  style="width: 100%; height: 300px"
                >
                  <GmapMarker
                    :position="marker.position"
                    :icon="marker.icon"
                    :clickable="true"
                  />
                </GmapMap>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </transition>
</template>

<script>
  import NotesPreview from "../notes/NotesPreview";
  import RecordingPreview from "../sessions/RecordingPreview";
  import ScreenshotsPreview from "../screenshots/ScreenshotsPreview";
  import {format, differenceInSeconds, setHours, setSeconds, setMinutes, subWeeks} from 'date-fns';
  import {mapState} from 'vuex';
  import {options, defaultMarker} from "../../services/googleMap";
  import FilesPreview from "../upload/FilesPreview";

  export default {
    name: 'CallDetails',
    components: {FilesPreview, ScreenshotsPreview, RecordingPreview, NotesPreview},
    props: {
      sessionLog: {
        type: Object
      }
    },


    data() {
      return {
        options,
      }
    },

    computed: {
      ...mapState({
        sessionsMap: state => state.sessions.map
      }),
      marker() {
        if (!this.currentSessionLog.coordinates) return null;
        return {
          ...defaultMarker,
          position: {
            lat: this.currentSessionLog.coordinates.coordinates[0],
            lng: this.currentSessionLog.coordinates.coordinates[1],
          },
        }
      },
      center() {
        return this.marker.position;
      },
      duration() {
        let log = this.currentSessionLog;
        if (log && log.initiatedAt && log.endedAt) {
          let durationInSecconds = differenceInSeconds(parseInt(log.endedAt), parseInt(log.initiatedAt));
          let hours = Math.floor(durationInSecconds / 3600);
          let secondsLeft = durationInSecconds - (hours * 3600);
          let minutes = Math.floor(secondsLeft / 60);
          let seconds = secondsLeft - (minutes * 60);

          let duration = '';
          if (hours) {
            duration += `${hours} hour${hours > 1 ? 's' : ''} `
          }

          if (minutes) {
            duration += `${minutes} min `
          }

          if (seconds) {
            duration += `${seconds} sec`
          }

          return duration;
        } else {
          return null
        }
      },

      currentSessionLog() {
        return this.sessionLog && this.sessionsMap[this.sessionLog.id]
      }
    },

    methods: {
      close() {
        this.$emit('close')
      },
      stopPropagation() {
      },
      formatDate(date) {
        return date ? format(parseInt(date), 'MMM DD YYYY') : null
      },
      formatTime(date) {
        return date ? format(parseInt(date), ' HH:mm:ss') : null
      },
      getLogPlatform(platform) {
        if (!platform || platform === 'IOS') {
          return 'iOS'
        } else {
          return 'Android'
        }
      },
      scrollToBottom() {
        this.$refs.scrollable.scrollTo({
          top: this.$refs.scrollable.scrollHeight,
          left: 0,
          behavior: 'smooth'
        });
        // this.$refs.scrollable.scrollTop = this.$refs.scrollable.scrollHeight;
      }
    },

    watch: {
      sessionLog() {
        if (this.sessionLog) {
          this.$store.dispatch('global/lockVideoSessionScreen')
        } else {
          this.$store.dispatch('global/unlockVideoSessionScreen')
        }
      }
    },
  }
</script>

<style lang="scss">
  @import "CallDetails";
</style>
